import { render, staticRenderFns } from "./GoogleAnalytics4.vue?vue&type=template&id=542d4bc0"
import script from "./GoogleAnalytics4.vue?vue&type=script&lang=js"
export * from "./GoogleAnalytics4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542d4bc0')) {
      api.createRecord('542d4bc0', component.options)
    } else {
      api.reload('542d4bc0', component.options)
    }
    module.hot.accept("./GoogleAnalytics4.vue?vue&type=template&id=542d4bc0", function () {
      api.rerender('542d4bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analytics/GoogleAnalytics4.vue"
export default component.exports